/* eslint-disable react/prop-types */
import React from "react";

import {Modal} from "react-bootstrap";
import Button from "components/Button";

export const ModalApp = ({show, handleModal, isMap = false, children}) => {
    return  <Modal
        show={show}
        onHide={ handleModal }
        backdrop="static"
        keyboard={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={`rounded-0 ${isMap && 'p-0'} `}
    >
        <Modal.Header
            closeButton
            className={`border-0 pb-0 ${isMap && 'close-button-custom'} position-absolute top-0`}
            style={{zIndex: 99, right: 0}}
        />
        <Modal.Body className="text-center p-0 m-0">
            {children}

            {isMap &&
                <div className="px-3 pb-3 position-absolute bottom-0 w-100"  style={{zIndex: 99}}>
                    <Button onClick={handleModal} className="close-button-bottom">Fechar</Button>
                </div>
            }
        </Modal.Body>
    </Modal>
}
